export default "/images/a646819313caa9c0b47d83519f5c15bb.avif";